<template>
    <div class="sc-1q5lmzx-0 hDcCcC h-auto" v-for="item in props.list" :key="item.id" style="border:1px solid rgba(0, 0, 0 ,.3)">
        <div class="bg-white px-2 pt-1 rounded" style="height:225px">
    <!-- کلید روی محصول -->
		<button-template v-if="!item.store_active" :id="item.id" :sid="item.place_id || item.store_place_id" :quantity="item.quantity" origin="product" />
    <!-- فروشگاه بسته است -->
    <span v-else class="product-new-top bg-red w-100 rounded d-flex bg-secondary" style="height: 30px;justify-content: center;align-items: center;">فروشگاه بسته است</span>
		<div @click="goProductPage(item.id,item.store_active)"> 
    <!-- {{ item.store_active }} -->
			<figure class="sc-1q5lmzx-2 ktLvGN thumbnail-Wrapper">
        <img :src="'https://radap.ir/'+item.img_url" class="product-img" :alt="item.stuff_name || item.name" > 
        <span class="product-name">{{item.stuff_name || item.name }}</span> 
        <span class="product-description text-muted">{{item.description }}</span> 
      </figure>
    </div>
    <!-- قیمت محصول -->
		<footer class="mb-1">
    <!-- تخفیف اگر داشت -->
				<div :class="{'visible' : item.discount > 0 , 'invisible' : item.discount == 0 }">
					<div>
            <del class="small pe-1 text-muted">{{convertToPersian(numberFormat(item.price))}}</del> 
						<label class="text-danger p--5 product-discount" :class="{'peculiar-discount' : item.discount > 4}">%{{convertToPersian(item.discount)}}</label> 
          </div> 
        </div>
          <div>
            <strong>{{convertToPersian(numberFormat((parseInt(removeCommos(item.price)) - (parseInt(removeCommos(item.price)) * (parseInt(item.discount) / 100)))))}}</strong>
            <small>تومان</small>
          </div>
		</footer>
	</div>
    </div>
</template>
<script setup>
import {defineProps} from 'vue'
import ButtonTemplate from './button.vue'
import router from '@/router';
import { convertToPersian, numberFormat,removeCommos } from '@/composables/digits';
let props = defineProps(['list']);
console.log(props.list);
function goProductPage(id,active){
  if(!active){
    router.push({name:'Single',params:{item:id}})
  }
}
</script>
<style scoped>
.heMFVq > *{
  margin: 1px !important;
  width: 100%;
}
@media (max-width: 950px){
  .heMFVq > *{
    width: 32%;
  }
}
@media (max-width: 450px){
  .heMFVq > *{
    width: 49%;
  }
}

.product-name{
    max-height: 22px;
    font-size: 14px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    margin-top: .25em;
    font-family: "IranSans";
}
.product-description{
    height: 22px;
    font-size: 11px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    font-family: "IranSans";
}
.product-img{
    max-height: 120px !important;
    min-height: 120px !important;
    max-width: 120px !important;
    min-width: 120px !important;
    margin-right: auto;
    margin-left: auto;
}
.product-discount{
  border: 1px solid red;
  line-height: 1.1;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
}
.p--5{
  padding: .25em .125em;
}


</style>